import { render, staticRenderFns } from "./PeppolEndpointInput.vue?vue&type=template&id=5c6ca276&scoped=true"
import script from "./PeppolEndpointInput.vue?vue&type=script&lang=ts"
export * from "./PeppolEndpointInput.vue?vue&type=script&lang=ts"
import style0 from "./PeppolEndpointInput.vue?vue&type=style&index=0&id=5c6ca276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6ca276",
  null
  
)

export default component.exports